var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24.8174,
    rx: 24,
    ry: 24.8174,
    fill: "#0081FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5404 25.1556C13.794 25.5605 13.8249 26.1536 14.6075 26.4738L16.9262 27.4225C17.7095 27.744 18.8946 27.5686 19.5585 27.0329L29.6275 18.8218C30.2895 18.2834 30.3604 18.3628 29.7856 18.9992L21.8256 27.8094C21.2488 28.4439 21.4191 29.2231 22.2049 29.5373L22.4766 29.6467C23.2624 29.9609 24.543 30.4886 25.3237 30.8169L27.8953 31.8996C28.6766 32.2279 29.5114 31.8409 29.7333 31.0003L33.6527 16.1032C33.874 15.2626 33.4443 14.9057 32.6978 15.31L14.5404 25.1556Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9037 34.9084C20.8579 35.0505 22.4895 32.4654 22.4895 32.4654C22.9508 31.7369 22.6888 30.8676 21.9095 30.538L20.1301 29.7848C19.3508 29.4553 18.9772 29.8422 19.2998 30.6474C19.2998 30.6474 20.9508 34.7623 20.9037 34.9084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.9542095bd6d91268415353a6ee52da6f.svg";
export { ForwardRef as ReactComponent };